import { clsx ,Box } from 'external/material'
import {DownloadIcon, MessageIcon, SquareArrowUpRightIcon} from 'resources/icons'
import {viewerGuard, subdomainLink} from 'utils/url'
import {inViewer} from 'settings'

export default function LessonLinks(props) {
  const {assignment, downloaded} = props
  const {id} = assignment

  return (<Box className="lessonLinks">
    {props.onMessageClick && <span onClick={e => {
      props.onMessageClick(e.currentTarget)
    }} className={clsx("lessonLink", "message")}><MessageIcon fill="#2c75bd" width={21} /></span>}
    {inViewer && downloaded && <a className={clsx("lessonLink", "view")} href={`//downloads/${id}`}><SquareArrowUpRightIcon fill="#2c75bd" height={20} /></a>} 
    {inViewer && !downloaded && <a
      className={clsx("lessonLink", "download")}
      {...viewerGuard({target: "_blank", href: subdomainLink('api-support', 'catalog',  'downloadUploaded', `?event=${id}`)})}
    ><DownloadIcon fill="#2c75bd" width={17} /></a>}
    </Box>)
}
